<template>
<div class="card">
    <div class="card-header">Assigned</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="04"/>

        <b-row>
            <b-col>
                <LifecycleCheckList lifecycleStatus="04" :requestId="request.id"
                v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
            </b-col>
        </b-row>
                        
        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col cols="12" lg="4">
                    <BaseSelector v-model="request.priority" 
                        :v="$v.request.priority"
                        label="Request Priority"
                        slug="priority"
                        :options=priorityOptions
                        :required="$v.request.priority.$params.required ? true : false"
                        tip="Determined with Division" />
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseDateInput v-model="request.preHireConsultDate" 
                        :v="$v.request.preHireConsultDate"
                        label="Pre Hire Consult Date"
                        slug="consult-date"
                        :required="$v.request.preHireConsultDate.$params.required ? true : false"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseSelector v-model="request.bargainingUnit" 
                        :v="$v.request.bargainingUnit"
                        label="Bargaining Unit"
                        slug="bargainingUnit"
                        :options=bargainingUnitOptions
                        :required="$v.request.bargainingUnit.$params.required ? true : false"
                        tip="" />
                </b-col>                
            </b-row>

            <b-row>
                <b-col cols="12">
                    <BaseParagraphInput v-model="request.assignmentComments"
                        :v="$v.request.assignmentComments" 
                        slug="assignmentComments"
                        :required="$v.request.assignmentComments.$params.required ? true : false"
                        label="Internal Comments"/>
                </b-col>
            </b-row>

            <b-row v-if="request.assignFeedback">
                <b-col cols="12">
                    <BaseTextOutput label="Requester Comments" :value="request.assignFeedback"
                        v-if="request.assignFeedback"/>
                </b-col>
            </b-row>
            
            <div>
                <b-button type="button" variant="primary" @click="submit">Complete Assigned Phase</b-button>
                <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
                <b-button type="button" variant="outline-danger" v-b-modal.modal-return-previous-lifecycle>Return to Requester</b-button>
            </div>
        </b-form>
        
    </div>

    <!-- Return Modal -->
    <b-modal id="modal-return-previous-lifecycle" hide-header hide-footer @hidden="close">
        <h2>Return To Requester</h2>
        <hr/>
        <form ref="form" @submit.prevent="returnToRequester()">
            <BaseParagraphInput v-model="returnPreviousLifecycleComments"
                          :v="$v.returnPreviousLifecycleComments"
                          slug="returnPreviousLifecycleComments"
                          :required="$v.returnPreviousLifecycleComments.$params.required ? true : false"
                          label="Reason for Returning to Requester"/>
            <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
            <b-button type="submit" variant="primary" :disabled="$v.returnPreviousLifecycleComments.$invalid">Submit</b-button>
        </form>
    </b-modal>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import { commonOptions } from '@/mixins/commonOptions.js'

export default {
    components: {
        LifecycleCheckList
    },
    mixins: [       
       commonOptions
    ],
    props: {
        request: Object
    },
    data() {
        return {
            priorityOptions: [
                { value: '1', text: 'P1' },
                { value: '2', text: 'P2' },
                { value: '3', text: 'P3' },
                { value: '4', text: 'P4' },
                { value: '5', text: 'P5' },
                { value: '6', text: 'P6' },
                { value: '7', text: 'P7' },
                { value: '8', text: 'P8' },
                { value: '9', text: 'P9' },
                { value: '10', text: 'P10' },
                { value: '11', text: 'P11' },
                { value: '12', text: 'P12' },
                { value: '13', text: 'P13' },
                { value: '14', text: 'P14' },
                { value: '15', text: 'P15' },
                { value: '16', text: 'P16' },
                { value: '17', text: 'P17' },
                { value: '18', text: 'P18' },
                { value: '19', text: 'P19' },
                { value: '20', text: 'P20' },
                { value: '999', text: ' ' },
            ],
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            }, 
            checklistComplete: false,
            saveOnly: false,
            returnPreviousLifecycleComments: null,
        }
    },
     validations: {
        checklistComplete: { checked: value => value === true },
         request: {
             priority: { required: false },
             preHireConsultDate: { required },
             bargainingUnit: { required },
             assignmentComments: { required: false, maxLength: maxLength(4000) },             
         },
         returnPreviousLifecycleComments: {required: false, maxLength: maxLength(4000)},
     },
    computed: { },
    created() { },
    mounted: function() {
        this.autosave()
    },
    beforeDestroy() {
       clearInterval(this.autosave_id)
    },
    watch: { },

    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },
        
        autosave() {          
            this.autosave_id = setInterval(() => {
                this.save()
            }, 300000);
        },

        async save() {
            this.saveOnly = true
            await this.submit()
            this.saveOnly = false
        },
        async submit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                priority: this.request.priority, 
                preHireConsultDate: this.request.preHireConsultDate,
                bargainingUnit: this.request.bargainingUnit,
                comments: this.request.assignmentComments,
                advanceNextLifecycle: !this.saveOnly
            }

            await axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/assign`, payload)
                  .then(response => {                 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                  })
                  
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        
        async returnToRequester() {
            await this.save()

            let payload = {
                requestId: this.request.id,
                comments: this.returnPreviousLifecycleComments
            }
        
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/manager/return/requester`, payload)
              .then(response => {
                this.showRootToast("HRM Request Has Been Sent to Reqester", "Success", "success")
                this.$router.push('/home')
              })
        },

        close() {
          this.$bvModal.hide("modal-return-previous-lifecycle")
          this.returnPreviousLifecycleComments=null
        },
    }   
}
</script>